import type { Photo } from '@/services/turbineService'

const VALID_BLADES = new Set(['A', 'B', 'C'])

export const getPhotoBlade = (photo: Photo | Record<string, any>): string | null => {
  const rawBlade = (photo as any)?.blade
  const normalizedBlade = typeof rawBlade === 'string' ? rawBlade.trim().toUpperCase() : null
  if (normalizedBlade && VALID_BLADES.has(normalizedBlade)) {
    return normalizedBlade
  }

  const candidates = [
    (photo as any)?.key,
    (photo as any)?.file_path,
    (photo as any)?.originalName,
    (photo as any)?.url,
    (photo as any)?.name
  ].filter(Boolean) as string[]

  for (const source of candidates) {
    const lower = source.toLowerCase()
    const match =
      lower.match(/blade[-_ ]?([abc])/i) ||
      lower.match(/operator([abc])/i) ||
      lower.match(/robot([abc])/i) ||
      lower.match(/drone([abc])/i) ||
      lower.match(/[_-]([abc])\d*(?:\.[a-z0-9]+)?$/i)

    const blade = match?.[1]?.toUpperCase()
    if (blade && VALID_BLADES.has(blade)) {
      return blade
    }
  }

  return null
}

/**
 * A photo "has edited versions" when at least one edited copy has been saved on
 * top of the original (version_count > 0). Used to visually flag such photos in
 * the sidebars. Pure predicate — no side effects, no React.
 */
export const photoHasEditedVersions = (photo: Photo | Record<string, any>): boolean => {
  const count = (photo as any)?.versionCount
  return typeof count === 'number' && count > 0
}
